import InactiveCellRenderer from "./InactiveCellRenderer";

export default class UserGroupCellRenderer extends InactiveCellRenderer {
    constructor(additionalCssClass) {
        super(additionalCssClass);
    }

    generateContent(cell) {
        let contentDiv = document.createElement("div");
        contentDiv.className = "userGroupName lockTableEllipsis";
        contentDiv.innerHTML = cell.getValue();

        cell.getCellEl().appendChild(contentDiv);
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/renderers/UserGroupCellRenderer.js